/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ActiveTab/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import DentalMonitoring from './DentalMonitoring/index'
import Documents from './Documents/index'
import Images from './Images/index'
import Ledger from './Ledger/index'
import Medical from './Medical/index'
import No from './No/index'
import Notes from './Notes/index'
import Profile from './Profile/index'
import React from 'react'
import TreatmentCard from './TreatmentCard/index'



/** @type {import('Simple/types.js').View} */
export default function ActiveTab({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let tabTabValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'tab',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: tabTabValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Profile'}>
<Profile
  viewPath={`${viewPath}/Profile`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Medical'}>
<Medical
  viewPath={`${viewPath}/Medical`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TreatmentCard'}>
<TreatmentCard
  viewPath={`${viewPath}/TreatmentCard`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Ledger'}>
<Ledger
  viewPath={`${viewPath}/Ledger`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Images'}>
<Images
  viewPath={`${viewPath}/Images`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Documents'}>
<Documents
  viewPath={`${viewPath}/Documents`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Notes'}>
<Notes
  viewPath={`${viewPath}/Notes`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'DentalMonitoring'}>
<DentalMonitoring
  viewPath={`${viewPath}/DentalMonitoring`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}